/** Superficie pública del módulo Promociones (ABM, engine compartido y tipos POS).
 * Lectura: snapshot/catálogo RAM. Escritura: online-only submitCommand → RPC (ADR-017).
 * Re-exporta desde domain-api, infra-api, app-api + UI directa. */
// Layered APIs — importar desde estas para evitar require cycles:
//   domain-api: tipos y funciones puras (cero dependencias)
//   infra-api: repos y queries
//   app-api: hooks, use cases, stores, presentation, engine
export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api para evitar cycles (components/screens importan de otros módulos)
export { PromotionRowCard } from './components/PromotionRowCard';
export { PromotionsFiltersPanel } from './components/PromotionsFiltersPanel';
export { PromotionsScreenHeader } from './components/PromotionsScreenHeader';
export { PromotionsBatchBar } from './components/PromotionsBatchBar';
export { PromotionTopPerformersCard } from './components/PromotionTopPerformersCard';

export { PromotionHistoryModal } from './components/PromotionHistoryModal';
export { PromotionConflictBanner } from './components/PromotionConflictBanner';
export { PromotionsListScreen } from './screens/PromotionsListScreen';
export { PromotionFormModal } from './components/PromotionFormModal';
